import React from 'react';
import styled from 'styled-components';
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import SchoolIcon from '@material-ui/icons/School';
import SettingsIcon from '@material-ui/icons/Settings';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import SpaIcon from '@material-ui/icons/Spa';
import LockIcon from '@material-ui/icons/Lock';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import SportsIcon from '@material-ui/icons/Sports';
import * as Guides from '../../core/collections/guides';

const SportsIconStyled = styled(SportsIcon)`
  transform: rotate(-25deg);
`;

export const topLinks = [
  {
    to: "/dashboard",
    reg: "(/dashboard/?)",
    text: "Dashboard",
    title: "Strivers Dashboard",
    header: "Dashboard",
    subText: "Wecome to the Strivers trainer portal",
    icon: <InsertChartOutlinedIcon />,
    guide: Guides.dashboardGuide,
    roles: ["trainer", "athlete", "admin"],
  },
  {
    to: "/profile",
    reg: "(/profile/?)",
    text: "Profile",
    title: "Strivers Trainer Profile",
    header: "Profile",
    subText: "Your profile",
    icon: <OndemandVideoIcon />,
    guide: Guides.channelGuide,
    roles: ["trainer", "athlete", "admin"],
  },
  {
    to: "/activities",
    reg: "(/activities/?)",
    text: "Activity",
    title: "Strivers Activities",
    header: "Activity",
    subText: "Find all things related to your activities here",
    icon: <SpaIcon />,
    subDirects: [
      { reg: "(/activities/([0-9]+)/?)", subText: "Edit your activity" },
    ],
    roles: ["trainer", "admin"],
  },
  {
    to: "/exercises",
    reg: "(/exercises/?)",
    text: "Exercise",
    title: "Strivers Exercises",
    header: "Exercise",
    subText: "Find all things related to your exercises here",
    icon: <FitnessCenterIcon />,
    guide: Guides.exerciseGuide,
    subDirects: [
      { reg: "(/exercises/demos/?)", subText: "View your exercise demos", guide: Guides.exerciseDemosGuide },
      { reg: "(/exercises/([0-9]+)/?)", subText: "Edit your exercise" },
    ],
    roles: ["trainer", "admin"],
  },
  {
    to: "/classes",
    reg: "(/classes/?)",
    text: "Class",
    title: "Strivers Classes",
    header: "Class",
    subText: "Find all things related to your workout classes here",
    icon: <SchoolIcon />,
    guide: Guides.classGuide,
    subDirects: [
      { reg: "(/classes/drafts/?)", subText: "View your class drafts", guide: Guides.classDraftsGuide },
      { reg: "(/classes/([0-9]+)/?)", subText: "Edit your class" },
    ],
    roles: ["trainer", "admin"],
  },
  {
    to: "/programs",
    reg: "(/programs/?)",
    text: "Program",
    title: "Strivers Program",
    header: "Program",
    subText: "Find all things related to your programs here",
    icon: <FormatListNumberedIcon />,
    subDirects: [
      { reg: "(/programs/drafts/?)", subText: "View your program drafts" },
      { reg: "(/programs/([0-9]+)/?)", subText: "Edit your program" },
    ],
    roles: ["trainer", "admin"],
  },
  {
    to: "/digital-coaching",
    reg: "(/digital-coaching/?)",
    text: "Digital Coaching",
    title: "Strivers Digital Coaching",
    header: "Digital Coaching",
    icon: <SportsIconStyled />,
    roles: ["staff", "trainer", "admin"],
  },
  {
    to: "/settings/account",
    reg: "(/settings/?)",
    text: "Settings",
    title: "Strivers Settings",
    header: "Settings",
    icon: <SettingsIcon />,
    subDirects: [
      {
        header: "Account",
        reg: "(/settings/account/?)",
        subText: "View and edit your account settings",
      },
      {
        header: "Password",
        reg: "(/settings/password/?)",
        subText: "Change your password"
      },
      {
        header: "Payment",
        reg: "(/settings/stripe/?)",
        subText: "View and edit your payment settings"
      },
    ],
    roles: ["trainer", "athlete", "admin"],
  },
  {
    to: "/staff/workouts",
    reg: "(/staff/?)",
    text: "Staff",
    title: "Strivers Staff",
    header: "Staff",
    icon: <LockIcon />,
    subDirects: [
      {
        header: "Program Generator",
        reg: "(/staff/workouts/?)",
        subText: "View and test program generator",
      },
    ],
    roles: ["staff", "admin"],
  },
]
